/* eslint-disable class-methods-use-this */
/* eslint-disable import/extensions */

import { LitElement, html, css } from "lit";

import { setLodgingSchema } from './shared/utils';
import {
  createDateObj,
} from "./shared/clientside_sitehelpers";
import { normalize, openprops, buttons } from "./shared/openprops.css.js";


import "./costs-onsite.js";
import "./extra-services.js";
import "./my-alert.js";
import "./my-rating.js";
import "./guest-book.js";
import "./my-slider.js";
import "./my-calendars.js";

class HouseDetails extends LitElement {
  static get styles() {
    return css`
      ${normalize}
      ${openprops}
      ${buttons}
      :host {
        color: var(--primary-text-color);
        height: 100%;
        margin-top: var(--size-3);
      }

      #mapid {
        display: block;
        height: 400px;
      }

      button {
        margin: var(--size-3) 0;
      }

      contact-form {
        padding: 0 1em;
      }

      guest-book {
        margin-top: 1em;
      }

      my-rating {
        --my-rating-active-color: var(--red-3);
        --my-rating-inactive-color: var(--gray-3);
      }

      .contentcontainer .content {
        padding: 0 1em 1em 1em;
      }

      .description {
        padding: 0 1em;
      }

      h1 {
        margin: var(--size-3);
        width: 100%;
      }

      .price {
        font-size: 2.5em;
        font-weight: 600;
        padding-right: 1em;
      }

      .slideranddescription {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 3em;
      }

      .description {
        max-width: 314px;
      }

      .discount {
        text-decoration: line-through;
        font-size: 70%;
        color: #bdbdbd;
      }

      .linebreaks {
        white-space: pre-wrap;
      }

      #cancellationterms {
        display: none;
      }
      

      @media screen and (max-width: 414px) {
        .slideranddescription {
          display: flex;
          justify-content: center;
        }
        my-slider {
          width: 330px;
          height: 260px
        }
        h1 {
          font-size: var(--font-size-4);
        }
      }

      @media screen and (min-width: 415px) {
        .slideranddescription {
          margin-left: 1em;
        }
        my-slider {
          width: 750px;
          height: 540px
        }
      }
    `;
  }

  render() {
    return html`
      <div class="contentcontainer">
        <div class="slideranddescription">
          <my-slider
            photos="${JSON.stringify(this.housedetails.photos)}"
            .houseName="${this.housedetails.name}"
          ></my-slider>
          <div class="description">
            ${this.housedetails.short_description}
            <br />
            ${this.housedetails.city}, ${this.housedetails.region},
            ${this.housedetails.country}
            <br />
            <my-rating
              amount="${this.housedetails.stars}"
            ></my-rating>
            <br />
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"/></svg>
            ${this.housedetails.bedrooms} slaapkamers
            <br />
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><rect fill="none" height="24" width="24"/><g><path d="M12,12.75c1.63,0,3.07,0.39,4.24,0.9c1.08,0.48,1.76,1.56,1.76,2.73L18,18H6l0-1.61c0-1.18,0.68-2.26,1.76-2.73 C8.93,13.14,10.37,12.75,12,12.75z M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1 C4.76,14.04,4.39,14,4,14c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85 C21.93,14.21,20.99,14,20,14c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M12,6c1.66,0,3,1.34,3,3 c0,1.66-1.34,3-3,3s-3-1.34-3-3C9,7.34,10.34,6,12,6z"/></g></svg> ${this.housedetails.maxpersons} personen
            ${this.housedetails.questionary_count
              ? html`<br />
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>
                  ${this.housedetails.questionary_points} `
              : ""}
            <br />
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><circle cx="4.5" cy="9.5" r="2.5"/><circle cx="9" cy="5.5" r="2.5"/><circle cx="15" cy="5.5" r="2.5"/><circle cx="19.5" cy="9.5" r="2.5"/><path d="M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"/></svg>
            ${this.housedetails.numberofpets
              ? html`
                  ${this.housedetails.numberofpets}
                  ${this._petOrPets(this.housedetails.numberofpets)}
                `
              : "geen huisdieren toegestaan"}
            ${this.housedetails.situation
              ? html`<br /><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><rect fill="none" height="24" width="24"/><path d="M18,6H9V4H7v2H6l-4,4v9h20v-9L18,6z M4,12h10v5H4V12z M20,17h-4v-6.17l2-2v0l2,2V17z"/></svg>${this.housedetails.type}
                  (${this.housedetails.situation}) `
              : ""}
            ${this.housedetails.location
              ? html`Ligging:
                ${this.housedetails.location
                  .map((location) => location.toLowerCase())
                  .join(", ")} `
              : ""}
            <br />
            ${this._waterParkBool
              ? html`
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"/><circle cx="16.5" cy="5.5" r="2.5"/></svg>Gratis toegang tot een waterpark
                  <br />
                `
              : ""}
            ${this.housedetails.general &&
            this.housedetails.general.indexOf("Niet roken") !== -1
              ? html`
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z"/></svg>
                  Roken niet toegestaan
                `
              : ""}
            ${this.housedetails.general &&
            this.housedetails.general.indexOf("Roken toegestaan") !== -1
              ? html`
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"/></svg>
                  Roken toegestaan
                `
              : ""}
            ${this.housedetails.general &&
            this.housedetails.general.indexOf("WiFi") !== -1
              ? html`
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/></svg>                  Wi-Fi
                `
              : ""}
            <br />

            ${this.price
              ? html`
                  <!-- date was selected -->
                  <span class="price">
                    ${this.priceWithoutDiscount
                      ? html`
                          <span class="discount"
                            >€ ${this.priceWithoutDiscount}</span
                          >
                        `
                      : ""}€
                    ${this.price} </span
                  ><br />
                  ${this._dateString}
                `
              : ""}
          </div>
        </div>
        <h1>${this.housedetails.name}</h1>

        <div class="content">
          <span class="linebreaks">${this.housedetails.description}</span>
          <br>
          <br>
          <span class="linebreaks">${this.housedetails.layouttext}</span>
          <br>
          <br>
          ${this.housedetails.remarks
            ? html`
                <my-alert severity="info">
                  <div slot="title">Let op</div>
                  <div slot="content">${this.housedetails.remarks}</div>
                </my-alert>
              `
            : ""}
          <div class="booking">
            <my-calendars
              housecode="${this.housedetails.code}"
              arrivaldate="${this.housedetails.arrival}"
              departuredate="${this.housedetails.departure}"
              maxpersons="${this.housedetails.maxpersons}"
            ></my-calendars>
          </div>
          ${this.housedetails.cancellationterms ? html `
          <button @click="${this._showCancellationTerms}">Toon annulerings voorwaarden</button> 
          <ul id="cancellationterms">
          ${this.housedetails.cancellationterms.split('- ').map(term => {
            if (term.length > 0) {
              return html`<li>${term}</li>`;
            }
          })}
          </ul>
          ` : ''}
          <button id="contact" @click=${this._showContactform}>Contact opnemen</button>
          <contact-form housecode=${this.housedetails.code}></contact-form>

          <link rel="stylesheet" href="/node_modules/leaflet/dist/leaflet.css">
          <div id="mapid"></div>
          <guest-book .comments="${this.comments}"></guest-book>
        </div>
          </div>
    `;
  }

  static get properties() {
    return {
      site: {
        type: String,
      },
      active: {
        type: Boolean,
      },
      housedetails: {
        type: Object,
      },
      houseCode: {
        type: String,
      },
      period: {
        type: String,
      },
      price: {
        type: String,
      },
      width: {
        type: String,
      },
      _previousHouseCode: {
        type: String,
      },
      arrivaldate: {
        type: String,
      },
      departuredate: {
        type: String,
      },
      departuredates: {
        type: Array,
      },
      _dateString: {
        type: String,
      },
      comments: {
        type: Array,
      },
      calendars: {
        type: String,
      },
      lodging: {
        type: String,
      }
    };
  }

  constructor() {
    super();
    this.housedetails = {};
    this.persons = 1;
    this.comments = [];

    this.departuredates = [];
  }


  async firstUpdated() {
    if (!this.arrivaldate || !this.departuredate) {
      // TODO ? no dates given, get the dates for the lowest price from the db
    }
    if (
      typeof housecode !== "undefined" &&
      this._previousHouseCode !== housecode
    ) {
      const locationSearch = new URLSearchParams(this.location.search);
      this._previousHouseCode = housecode;
      // page was loaded for the first time, load house data
      // this.period = state.app.userInput.periode || '1week';
      this.houseCode = housecode;
      this.price = undefined;
    }
    await this._setMatomo(this.housedetails);
    this._createMap();
  }

  _showCancellationTerms() {
    this.shadowRoot.getElementById('cancellationterms').style.display = 'block';
  }

  async _createMap() {
    const {map, tileLayer, marker, Icon } = await import('leaflet/dist/leaflet-src.esm.js'); // @todo make clientside
    const mapEl = this.shadowRoot.querySelector("#mapid");
    let houseMap = map(mapEl).setView(
      [this.housedetails.latitude, this.housedetails.longitude],
      13
    );

    let urlTemplate = "https://familievakantiehuis.nl/tile/{z}/{x}/{y}.png";
    houseMap.addLayer(
      tileLayer(urlTemplate, {
        minZoom: 4,
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      })
    );
    Icon.Default.imagePath = "/images/leaflet/";
    marker([this.housedetails.latitude, this.housedetails.longitude]).addTo(houseMap);
  }

  _petOrPets(numberofpets) {
    return numberofpets > 1 ? "huisdieren" : "huisdier";
  }

  async _showContactform() {
    this.shadowRoot.getElementById('contact').remove();
    import('./contact-form');
  }

  _getDepartureDate(){
    // get the date from the url or the first available date from the housedata
    const locationSearch = new URLSearchParams(window.location.search);

    this.departuredate = locationSearch.get("vertrek")
      ? createDateObj(nlDateToIsoDate(locationSearch.get("vertrek")))
      : createDateObj(this.housedetails.departure);
  }

  async _setMatomo(houseData){
    window._paq.push(["setCustomUrl", window.location.pathname]);
    window._paq.push(["setDocumentTitle", `${houseData.name}, ${houseData.maxpersons} personen`]);
    window._paq.push(["trackPageView"]);
  }

  _handleResponse(houseData) {
  
    this._maxPersons = houseData.maxpersons;
    if (locationSearch.get("personen")) {
      this.persons =
        locationSearch.get("personen") <= this._maxPersons
          ? locationSearch.get("personen")
          : this._maxPersons;
    } else {
      this.persons = this._maxPersons;
    }

    this._waterParkBool = !!(
      houseData.general &&
      houseData.general.indexOf("Gratis toegang tot waterpark") !== -1
    );
   




    this._setPrice(this.arrivaldate, this.departuredate);
  }
}

customElements.define("house-details", HouseDetails);
